import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { send2FaCode } from '@api/userProfile';

import { TMutateModalHandlers } from '@interfaces/common/handlers';
import { IResponseError } from '@interfaces/errors/apiErrors';
import { ISendCode2FaDTO } from '@interfaces/user/dto/userProfileDTO';
import { ISendCodeForChangePasswordWith2Fa } from '@interfaces/user/userProfile';

import { SEND_CODE_2FA, USER_PROFILE } from '@constants/queryKeys';

export const useMutateSentCode = ({ onSuccess, onError }: TMutateModalHandlers) => {
	const queryClient = useQueryClient();

	const {
		mutateAsync: sendCode,
		isLoading: isLoadingSendCode,
	} = useMutation<ISendCode2FaDTO & ISendCodeForChangePasswordWith2Fa>({
		mutationKey: [SEND_CODE_2FA],
		mutationFn: ({
			code,
			number,
		}: ISendCode2FaDTO & ISendCodeForChangePasswordWith2Fa) => {
			return send2FaCode({
				code,
				number,
			});
		},
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [queryClient.invalidateQueries([USER_PROFILE])];
		},
		onError: (err: IResponseError) => {
			if (onError) onError(err);
		},
	});

	return {
		sendCode,
		isLoadingSendCode,
	};
};
